import { pluginConfigDoc, pluginConfigPpt, pluginConfigProcesson } from '.'

const pluginConfigMap = {
  doc: pluginConfigDoc,
  ppt: pluginConfigPpt,
  processon: pluginConfigProcesson,
}

export const getPluginInfo = (type: string) => {
  return pluginConfigMap[type as keyof typeof pluginConfigMap]
}
